import { Navigate } from 'react-router-dom';
import React from 'react';

import { useAuthenticate } from '@/context/AuthenticateContext';
import { PAGES } from './routeInitial.state';

export const ProtectedGuestRoutes = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const { isLoggedIn } = useAuthenticate();
  if (isLoggedIn) {
    return <Navigate to={PAGES.API_CLIENTS.path} />;
  }
  return <>{children}</>;
};
